import {
  DonationFormWrapper,
  DonationFormRow,
  PaymentElementWrapper
} from "./DonationForm.styles";
import { Skeleton, Box } from "@mui/material";

function DonationFormSkeleton() {
  return (
    <Box sx={{ maxWidth: '1440px', marginLeft: 'auto', marginRight: 'auto' }}>
      <DonationFormWrapper>
        <Skeleton sx={{ fontSize: 'var(--font-size-xl)', marginBottom: '20px' }}/>
        <Skeleton variant="rectangular" height={100} width={'100%'} sx={{ marginBottom: '30px' }}/>

        <Skeleton sx={{ fontSize: 'var(--font-size-xl)', marginBottom: '20px' }}/>
        <Skeleton variant="rectangular" height={100} width={'100%'} sx={{ marginBottom: '30px' }}/>

        <Box sx={{ maxWidth: '1440px', marginLeft: 'auto', marginRight: 'auto' }}>
          <DonationFormRow>
            <Box sx={{ minWidth: '55vw' }}>
              <Skeleton sx={{ fontSize: 'var(--font-size-xl)', width: '30%' }}/>
              <DonationFormRow>
                <Skeleton sx={{ fontSize: 'var(--font-size-md)', minWidth: '30%', marginRight: '15px' }}/>
                <Skeleton sx={{ fontSize: 'var(--font-size-md)', minWidth: '30%', marginRight: '15px' }}/>
                <Skeleton sx={{ fontSize: 'var(--font-size-md)', minWidth: '30%', marginRight: '15px' }}/>
              </DonationFormRow>
              <DonationFormRow>
                <Skeleton variant="rectangular" sx={{ borderRadius: '5px', height: '50px', minWidth: '30%', marginRight: '15px', marginBottom: '5px' }}/>
                <Skeleton variant="rectangular" sx={{ borderRadius: '5px', height: '50px', minWidth: '30%', marginRight: '15px', marginBottom: '5px' }}/>
                <Skeleton variant="rectangular" sx={{ borderRadius: '5px', height: '50px', minWidth: '30%', marginRight: '15px', marginBottom: '5px' }}/>
              </DonationFormRow>

              <Skeleton sx={{ fontSize: 'var(--font-size-xl)', width: '30%', marginTop: '30px' }}/>
              <PaymentElementWrapper>
                <Skeleton variant="rectangular" sx={{ borderRadius: '5px', height: '200px', width: '95%', marginRight: '15px' }}/>
              </PaymentElementWrapper>
            </Box>

            <Box sx={{ width: '295px' }}>
              <Skeleton sx={{ fontSize: 'var(--font-size-xl)', width: '40%', marginBottom: '30px' }}/>
              <Skeleton sx={{ fontSize: 'var(--font-size-l)', width: '50%', marginBottom: '30px' }}/>
              <Skeleton variant="rectangular" sx={{ borderRadius: '5px', height: '280px', width: '295px', marginBottom: '20px' }}/>
              <Skeleton variant="rectangular" sx={{ borderRadius: '5px', height: '50px', width: '295px' }}/>
            </Box>
          </DonationFormRow>
        </Box>
      </DonationFormWrapper>
    </Box>
  )
}

export default DonationFormSkeleton;
